// extracted by mini-css-extract-plugin
export default {"aside":"DoubleNavbar_aside__DZWio","mainLink":"DoubleNavbar_mainLink__U9FIO"};